import { DisputeStatus } from "@portal/types/entities/dispute";
import { DisputeStatusConfig } from "./type";

const disputeStatusConfig: DisputeStatusConfig = {
  OPEN: {
    "--statusTextColor": "var(--red-6)",
    "--statusBorderColor": "var(--red-4)",
  },
  WAITING_ON_CUSTOMER: {
    "--statusTextColor": "var(--gold-6)",
    "--statusBorderColor": "var(--gold-4)",
  },
  CLOSED: {
    "--statusTextColor": "var(--green-6)",
    "--statusBorderColor": "var(--green-4)",
  },
};

export function getDisputeStatusConfig(status?: DisputeStatus) {
  if (!status) return;
  return disputeStatusConfig[status];
}
